<template>
  <div style="width: 100%; padding: 1px">
    <b-row style="padding: 4px">
      <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
        <b-card class="sa-card" style="height: 100%" header-tag="header" footer-tag="footer" title="">
          <template #header>
            <div style="display: flex">
              <span style="flex: 1">Dati Struttura</span>
            </div>
          </template>
          <b-row>
            <b-col cols="12">
              <div style="padding: 2px; margin-left: 10px">
                <b class="sa-label-data">{{ jsonData.strutturaDenominazione }} ({{ jsonData.strutturaCodice }})</b>
                <span class="sa-label-data">{{ jsonData.strutturaIndirizzo }}, {{ jsonData.strutturaCap }}, {{
                  jsonData.strutturaLocalitaCodiceIstat }} ({{ jsonData.strutturaProvincia }})</span>
                <span class="sa-label-data"><b>P.IVA: </b>{{ jsonData.strutturaPartitaIva }} <b>C.F.: </b> {{
                  jsonData.strutturaCodiceFiscale }}</span>
                <span class="sa-label-data"><b>Telefono: </b>{{ jsonData.strutturaTelefono }} <b>Fax: </b> {{
                  jsonData.strutturaFax }}</span>
                <span class="sa-label-data"><b>E-Mail: </b>{{ jsonData.strutturaEmail }}</span>
                <span class="sa-label-data"><b>Pec: </b>{{ jsonData.strutturaPec }}</span>
                <span class="sa-label-data"><b>Iban: </b>{{ jsonData.strutturaIban }}</span>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
        <b-card class="sa-card" style="height: 100%" header="chartParams.title" header-tag="header" footer-tag="footer"
          title="">
          <template #header>
            <div style="display: flex">
              <span style="flex: 1">Dati Documento</span>
              <!-- <b-button size="sm" variant="outline-secondary outline-secondary-noborder pull-right" @click="onClickSelezionaDatiDocumento()">
                <i class="fas fa-pencil-alt"></i>
              </b-button> -->
            </div>
          </template>
          <div style="padding: 2px; margin-left: 10px">
            <b class="sa-label-data">Num. Doc.: <span style="font-weight: 300 !important">{{ jsonData.documentoNumero
            }}</span>
            </b>
            <b class="sa-label-data">Data Doc.: <span style="font-weight: 300 !important">{{
              formatDate(jsonData.documentoData) }}</span></b>
            <b class="sa-label-data">Tipo Doc.: <span style="font-weight: 300 !important">{{
              getTipoDocumentoDescrizione(jsonData.tipoDocumentoId) }}</span>
            </b>
            <b class="sa-label-data">Causale: <span style="font-weight: 300 !important">{{
              getDescriptionCasuali(jsonData.causaleDocumentoId) }}</span>
            </b>
            <!-- <b class="sa-label-data"
              >Sogg. Collegati: <span style="font-weight: 300 !important">{{ jsonData.soggettiCollegati }}</span>
            </b> -->
          </div>
        </b-card>
      </b-col>
      <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
        <b-card class="sa-card" style="height: 100%" header-tag="header" footer-tag="footer" title="">
          <template #header>
            <div style="display: flex">
              <span style="flex: 1">Destinazione </span>
              <!-- <b-button size="sm" variant="outline-secondary outline-secondary-noborder pull-right" :disabled="jsonData.tipoDocumentoId == null && jsonData.causaleDocumentoId == null" @click="onClickCliente()">
                <i class="fas fa-pencil-alt"></i>
              </b-button> -->
            </div>
          </template>
          <b-card-text>
            <div style="padding: 2px; margin-left: 10px">
              <b class="sa-label-data">{{ jsonData.soggettoCognomeRagione }} {{ jsonData.soggettoNome }}</b>
              <span class="sa-label-data"><b>Destinatario: </b> {{ jsonData.magazzinoDescrizione }}({{
                jsonData.magazzinoCodice }})</span>
              <span class="sa-label-data">{{ getIndirizzoSoggetto() }}</span>
              <span class="sa-label-data"><b>P.IVA: </b>{{ jsonData.soggettoPartitaIva }} </span>
              <span class="sa-label-data"> <b>C.F.: </b> {{ jsonData.soggettoCodiceFiscale }} </span>
              <span class="sa-label-data"> <b>Met. Pagamento: </b> {{ jsonData.metodoPagamentoDescrizione }} </span>
            </div>
          </b-card-text>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import StruttureMixin from "../../strutture/mixins/StruttureMixin";
import moment from "moment";
import ContabilitaMixin from "../mixins/ContabilitaMixin";

export default {
  mixins: [StruttureMixin, ContabilitaMixin],
  components: {},
  data() {
    return {
      id: null,
      presidio: {},
      jsonData: {},
    };
  },
  mounted() {
    this.id = this.$route.params.id;
    this.contabilitaTipoDocumentoLoadData(this.presidio.codiceStruttura);
    this.contabilitaCausaliDocumentoLoadData(this.jsonData.tipoDocumentoId);
  },
  watch: {},
  methods: {
    init(jsonData) {
      this.jsonData = jsonData;
    },
    formatDate(value) {
      if (value) {
        return moment(new Date(value)).format("DD-MM-YYYY");
      } else {
        return "---";
      }
    },

    getIndirizzoSoggetto() {
      const indirizzo = this.jsonData.soggettoIndirizzo || "";
      const cap = this.jsonData.soggettoCap || "";
      const provincia = this.jsonData.soggettoProvincia || "";
      const localita = this.jsonData.soggettoLocalita || "";
      let returnValue = [];
      if (indirizzo) {
        returnValue.push(indirizzo);
      }
      if (cap) {
        returnValue.push(cap);
      }
      if (provincia) {
        returnValue.push(`(${provincia})`);
      }
      if (localita) {
        returnValue.push(localita);
      }
      return returnValue.join(", ");
    },
  },
};
</script>

<style scoped>
/* .card-body {
  border-radius: 3px;
  border-left: 2px solid var(--bg-sidebar);
  border-top: 1px solid var(--bg-main-nav-bar);
  border-bottom: 1px solid var(--bg-main-nav-bar);
  border-right: 1px solid var(--bg-main-nav-bar);
  padding: 7px !important;
  margin-bottom: 5px;
} */

.sa-card {
  border-radius: 14px !important;
  border: 1px solid rgba(0, 0, 0, 0.06);
  border-left: 4px solid var(--bg-sidebar) !important;
  background-color: #ffffff !important;
  height: 100%;
  padding: 12px !important;
  margin-bottom: 12px !important;
  box-shadow:
    0 8px 18px rgba(0, 0, 0, 0.06),
    0 4px 6px rgba(0, 0, 0, 0.04) !important;
  transition:
    transform 0.30s ease,
    box-shadow 0.30s ease !important;
}

.sa-card-warning {
  border-left: 4px solid #ffffff !important;
}

.sa-card:hover {
  transform: translateY(-2px);
  box-shadow:
    0 10px 28px rgba(0, 0, 0, 0.10),
    0 4px 10px rgba(0, 0, 0, 0.06);
}

.card-header {
  border-radius: 9px !important;
  border-left: 2px solid var(--bg-sidebar) !important;
  border-top: 1px solid var(--bg-main-nav-bar) !important;
  border-bottom: 1px solid var(--bg-main-nav-bar) !important;
  border-right: 1px solid var(--bg-main-nav-bar) !important;
  padding: 7px !important;
  margin-bottom: 5px !important;
}
</style>
